import { call, put, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../interfaces";
import {
  ADD_SCHOOL,
  AddSchoolAction,
  DELETE_SCHOOL,
  DeleteSchoolAction,
  GET_SCHOOL,
  GET_SCHOOLS,
  GET_SCHOOL_SELECT_LIST,
  GetSchoolAction,
  GetSchoolSelectListAction,
  GetSchoolsAction,
  UPDATE_SCHOOL,
  UpdateSchoolAction,
} from "./actionTypes";
import {
  addSchoolError,
  addSchoolSuccess,
  deleteSchoolError,
  deleteSchoolSuccess,
  getSchoolError,
  getSchoolSelectListError,
  getSchoolSelectListSuccess,
  getSchoolSuccess,
  getSchoolsError,
  getSchoolsSuccess,
  updateSchoolError,
  updateSchoolSuccess,
} from "./actions";
import {
  addSchool,
  deleteSchool,
  getSchool,
  getSchoolSelectList,
  getSchools,
  updateSchool,
} from "../../helpers/backend_helper";

function* getSchoolsSaga({ payload: { request, history } }: GetSchoolsAction) {
  try {
    const response: ResponseGenerator = yield call(
      getSchools,
      request as PaginateQuery
    );
    yield put(getSchoolsSuccess(response.data));
  } catch (error) {
    yield put(getSchoolsError(error));
  }
}

function* getSchoolSaga({ payload: { id, history } }: GetSchoolAction) {
  try {
    const response: ResponseGenerator = yield call(getSchool, id);
    yield put(getSchoolSuccess(response.data));
  } catch (error) {
    yield put(getSchoolError(error));
  }
}

function* getSchoolSelectListSaga({
  payload: { governorateId, cityId, history },
}: GetSchoolSelectListAction) {
  try {
    const response: ResponseGenerator = yield call(
      getSchoolSelectList,
      governorateId,
      cityId
    );
    yield put(getSchoolSelectListSuccess(response.data));
  } catch (error) {
    yield put(getSchoolSelectListError(error));
  }
}

function* addSchoolSaga({ payload: { request, history } }: AddSchoolAction) {
  try {
    yield call(addSchool, request);
    yield put(addSchoolSuccess());
  } catch (error) {
    yield put(addSchoolError(error));
  }
}

function* updateSchoolSaga({
  payload: { id, request, history },
}: UpdateSchoolAction) {
  try {
    yield call(updateSchool, id, request);
    yield put(updateSchoolSuccess());
  } catch (error) {
    yield put(updateSchoolError(error));
  }
}

function* deleteSchoolSaga({ payload: { id, history } }: DeleteSchoolAction) {
  try {
    yield call(deleteSchool, id);
    yield put(deleteSchoolSuccess());
  } catch (error) {
    yield put(deleteSchoolError(error));
  }
}

function* SchoolSaga() {
  yield takeEvery(GET_SCHOOLS, getSchoolsSaga);
  yield takeEvery(GET_SCHOOL, getSchoolSaga);
  yield takeEvery(GET_SCHOOL_SELECT_LIST, getSchoolSelectListSaga);
  yield takeEvery(ADD_SCHOOL, addSchoolSaga);
  yield takeEvery(UPDATE_SCHOOL, updateSchoolSaga);
  yield takeEvery(DELETE_SCHOOL, deleteSchoolSaga);
}

export default SchoolSaga;
